import { ProtoParams, UrlParams } from 'src/app/@core/types';
import { environment } from 'src/environments/environment';
import { urlParamsFromObject } from 'src/app/@shared/utils';

export class ProtoUrl {
  private static endpointsWithoutAuthentication: ProtoParams[] = [
    {
      methods: ['POST'],
      path: '/users/login',
    },
    {
      methods: ['POST'],
      path: '/users/reset-password',
    },
    {
      methods: ['POST'],
      path: '/auth',
    },
    // wildcard matching
    // {
    //   methods: ['GET'],
    //   path: '/path/*',
    // },
  ];

  public static get baseUrl(): string {
    return environment.apiBaseUrl;
  }

  public static get url(): string {
    return `${this.baseUrl}/${this.apiVersion}`;
  }

  public static get getUrl() {
    return (path: string, params?: UrlParams): string => {
      return `${this.url}/${path}${this.transformParamsToString(params)}`;
    };
  }

  public static get getMockUrl() {
    return (path: string, params?: UrlParams): string => {
      return `./assets/mocks/${path}/index.json${this.transformParamsToString(params)}`;
    };
  }

  public static get authLogin() {
    return (): string => {
      return `${this.url}/auth/login`;
    };
  }

  public static get authRegister() {
    return (): string => {
      return `${this.url}/auth/register`;
    };
  }

  public static get authRequestPasswordReset() {
    return (): string => {
      return `${this.url}/auth/request-password-reset`;
    };
  }

  public static get authResetPassword() {
    return (): string => {
      return `${this.url}/auth/reset-password`;
    };
  }

  public static get authLogout() {
    return (): string => {
      return `${this.url}/auth/logout`;
    };
  }

  public static get requestDatareview() {
    return (): string => {
      return `${this.url}/datareviews`;
    };
  }

  public static get formDatareview() {
    return (id: string, params?: UrlParams): string => {
      return `${this.baseUrl}/pwa/organization-data-review/${id}${this.transformParamsToString(params)}`;
    };
  }

  public static get updateDatareviewsChangedOrganization() {
    return (): string => {
      return `${this.url}/datareviews/update-changed-organization`;
    };
  }

  public static get consents() {
    return (params?: UrlParams): string => {
      return `${this.url}/consents${this.transformParamsToString(params)}`;
    };
  }

  public static get appVersions() {
    return (params?: UrlParams): string => {
      return `${this.url}/app-versions${this.transformParamsToString(params)}`;
    };
  }

  public static get files() {
    return (params?: UrlParams): string => {
      return `${this.url}/files${this.transformParamsToString(params)}`;
    };
  }

  public static get filesUpload() {
    return (): string => {
      return `${this.url}/files/upload`;
    };
  }

  public static get filesUploadFromUrl() {
    return (): string => {
      return `${this.url}/files/upload-from-url`;
    };
  }

  public static get filesDownload() {
    return (id: string, params?: UrlParams): string => {
      return `${this.url}/files/${id}/download${this.transformParamsToString(params)}`;
    };
  }

  public static get filesDownloadById() {
    return (id: string, params?: UrlParams): string => {
      return `${this.url}/files/${id}/download/${this.transformParamsToString(params)}`;
    };
  }

  public static get filesById() {
    return (id: string): string => {
      return `${this.url}/files/${id}`;
    };
  }

  public static get apiVersion(): string {
    return 'api';
  }

  public static needsAuthentication(url: string, method: string): boolean {
    if (!url.includes(this.url)) { return false; }

    const [urlWithoutParams] = url.split('?');
    const path = urlWithoutParams.replace(this.url, '');

    const endpoint = this.endpointsWithoutAuthentication.find((item): boolean => {
      return this.matchWildcardString(path, item.path);
    });

    if (!endpoint || !endpoint.methods.includes(method)) { return true; }

    return false;
  }

  private static transformParamsToString(params: UrlParams): string {
    if (!params) { return ''; }

    let filterString = '';
    let queryParamsString = '';

    if (params.filter) {
      filterString = `filter=${encodeURIComponent(JSON.stringify(params.filter))}`;
    }

    if (params.queryParams) {
      queryParamsString = `${filterString
        ? '&'
        : ''}${urlParamsFromObject(params.queryParams)}`;
    }

    return `?${filterString}${queryParamsString}`;
  }

  private static matchWildcardString(str: string, rule: string): boolean {
    // eslint-disable-next-line require-unicode-regexp
    const escapeRegex = (value): string => { return value.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1'); };

    // eslint-disable-next-line require-unicode-regexp
    return new RegExp(`^${rule.split('*').map(escapeRegex)
      .join('.*')}$`).test(str);
  }
}
